import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

type ImportProjectJobsProgressState = {
  percent: number;
};

type ImportProjectJobsProgressResponse = {
  state: ImportProjectJobsProgressState | null;
};

export const getImportProjectJobsProgress = async (projectUuid: string) => {
  const { data } = await getRequest<ImportProjectJobsProgressResponse>(
    API.GET.getImportProjectJobsProgress(projectUuid),
  );

  return data;
};

type ImportProjectJobsProgressQueryOptions = Omit<
  UseQueryOptions<ImportProjectJobsProgressResponse>,
  'queryKey' | 'queryFn'
>;

export const useGetImportProjectJobsProgress = (
  projectUuid: string,
  options?: ImportProjectJobsProgressQueryOptions,
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROJECT_JOBS_IMPORT_PROGRESS, projectUuid],
    queryFn: () => getImportProjectJobsProgress(projectUuid),
    retry: false,
    enabled: false,
    ...options,
  });
};
